export default {
    data() {
        return {
            apis: {
                tree: 'sh/org/tree',//获取组织机构树
            },
            orgProps: {
                label: 'name',
                children: 'subs'
            },
            orgs: [],
            defaultExpanded: [],
            curOrg: {},
        }
    },
    props: {
        orgKey: String,//指定机构，如果指定该参数，则仅仅加载该机构及其子机构,
        orgCode:String,//指定机构，如果指定该参数，则仅仅加载该机构及其子机构,
    },
    watch: {
        orgKey(){
            this.loadOrgTree();
        },
        orgCode(){
            this.loadOrgTree()
        }
    },
    mounted() {
        const me = this;
        me.loadOrgTree();
    },
    methods: {
        // 请求组织机构树数据
        loadOrgTree: function () {
            const me = this;
            me.$post({
                url: me.apis.tree,
                params: {
                    orgCode: me.orgCode,
                    orgKey: me.orgKey
                }
            }).then(rsp => {
                let root = null;
                if(rsp.retList && rsp.retList.length > 0){
                    let org = rsp.retList[0].org;
                    if((me.orgKey && org.id != me.orgKey) || (me.orgCode && org.code != me.orgCode)){
                        return;
                    }
                    me.orgs = rsp.retList;
                    root = org;
                    if (me.curOrg == null || !me.curOrg.id) {
                        for (var key in root) {
                            me.$set(me.curOrg, key, root[key]);
                        }
                    }
                    me.defaultExpanded.push(root.id);
                }
                //触发数据加载完成事件
                me.$emit('data-load', me.orgs, root);
            });
        },
        nodeClick(data, node, me) {
            this.$emit('node-click', data, node, me)
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/org/tree/src/tree.js